<template>
    <div>
        <div class="flex justify-center mt-5">
            <hts-avatar
                :src="avatar"
                online
                size="x-large" />
        </div>
        <div class="flex justify-center mt-5">
            <hts-form-button
                size="small"
                @click="openUploadImage">
                {{ $t('labels.changeAvatar') }}
            </hts-form-button>
            <hts-form-upload-image
                ref="uploadImage"
                color="info"
                @upload-success="uploadSuccessImage" />
        </div>
        <hts-form
            :rules="rules"
            class="space-y-6"
            @submit="handleUpdateCompanyUser">
            <div class="flex justify-center gap-4 mt-10">
                <div class="w-[500px] flex flex-col gap-5">
                    <hts-form-input
                        v-model="companyUser.fullName"
                        required
                        :label="$t('labels.fullName')"
                        prop="fullName"
                        name="fullName" />
                    <hts-form-input
                        v-if="companyUser.registerBy === 'email'"
                        v-model="companyUser.contactEmail"
                        required
                        class="w-full"
                        :label="$t('labels.contactEmail')"
                        prop="contactEmail"
                        name="contactEmail" />
                    <hts-form-phone
                        v-if="companyUser.registerBy === 'phone'"
                        v-model="companyUser.phone"
                        required
                        class="w-full"
                        :label="$t('labels.phone')"
                        prop="phone"
                        name="phone" />
                    <hts-form-input
                        v-model="companyUser.address"
                        required
                        class="w-full"
                        :label="$t('labels.address')"
                        prop="address"
                        name="address" />

                    <div class="flex flex-row gap-5 justify-end">
                        <hts-form-button
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="getData">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                    </div>
                </div>
            </div>
        </hts-form>
    </div>
</template>

<script setup lang="ts">
const store = $store()
const user = store.userConfig.getUser
const showSlideOverEditProfile = ref(false)
const uploadImage = ref()
const avatar = computed(() => {
  return store.userConfig.getAvatar
})
const _initCompanyUser = {
  id: '',
  registerBy: '',
  fullName: '',
  contactEmail: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  } as {[key :string]: any} | null,
  address: '',
  jobTitle: '',
  group: ''
}
const companyUser = reactive(_initCompanyUser)

const dropdownMenuClick = (action: String) => {
  switch (action) {
  case 'editInfoUser':
    showSlideOverEditProfile.value = true
  }
}

onMounted(async () => {
  await getData()
})

const getData = async () => {
  // ở workspace user sẽ update thông tin của company user
  const api = {
    url: '/auth/company-user',
    method: 'get'
  }
  const data = await $api(api)
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    companyUser.id = resData.data._id
    companyUser.registerBy = resData.data.registerBy
    companyUser.fullName = resData.data.fullName
    companyUser.address = resData.data.address
    companyUser.jobTitle = resData.data.jobTitle
    companyUser.group = resData.data.group

    companyUser.contactEmail = companyUser.registerBy === 'email' ? resData.data.contactEmail : null

    if (companyUser.registerBy === 'phone') {
      if (!resData.data.phone || typeof resData.data.phone === 'string') {
        companyUser.phone = {
          phone: resData.data.phone || '',
          code: '+84',
          countryCode: 'Vietnam +84'
        }
      } else {
        companyUser.phone = resData.data.phone
      }
    } else {
      companyUser.phone = null
    }
  }
}

const openUploadImage = () => {
  if (uploadImage.value) {
    uploadImage.value.open()
  }
}

const uploadSuccessImage = (data: { [key: string]: string }) => {
  store.userConfig.setAvatar(data.avatar)
}

const handleUpdateCompanyUser = async () => {
  const api = {
    url: '/auth/company-user',
    method: 'put'
  }

  const data = await $api(api, { body: companyUser })
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    process.client && $toast().success($t('labels.updateSuccess'))

    const response = await $api($url.system.getSystemConfig)
    const responseData: any = $lodash.get(response, 'data.value')
    if (responseData.success) {
      const configData = responseData.data || {}
      const user = configData.user || {}
      store.userConfig.setUser(user)
    }
  }
}

const rules = computed(() => {
  const r = {
    fullName: 'required',
    address: 'required'
  } as {[key :string]: any}

  if (companyUser.registerBy === 'email') {
    r.contactEmail = 'required|email'
  }

  if (companyUser.registerBy === 'phone') {
    r.phone = 'required'
  }
})

</script>
